/**
 * Third-party tags (gtag, fbq, GTM, tawk.to) cannot be unloaded once their
 * scripts run. We remember which shop loaded them so a client-side switch to
 * another shop (path-based hosts: /shop-a → /shop-b or /platform) reloads the
 * page instead of reporting shop B's traffic to shop A's IDs.
 */
let trackingShopSlug: string | null = null

export function markTrackingLoaded(slug: string): void {
  trackingShopSlug = slug
}

export function trackingLoadedForShop(): string | null {
  return trackingShopSlug
}

/** Admin pages live at `/admin` on custom domains and `/{slug}/admin` on path-based hosts. */
export function isShopAdminPath(path: string, slug: string): boolean {
  const prefix = `/${slug}`
  const local = slug && (path === prefix || path.startsWith(`${prefix}/`))
    ? path.slice(prefix.length) || '/'
    : path
  return /^\/admin(\/|$)/.test(local)
}
